import { useSuspenseQuery } from "@tanstack/react-query";
import { formMetadataQueryKeys } from "./formMetadataQueryKeys";
import { getFormMetadata } from "./getFormMetadata";
import { useMetadataParamsContext } from "./metadata-params-provider";

export const useMetadataQuery = () => {
    const formMetadataParams = useMetadataParamsContext();

    const formMetadataQueryKey = formMetadataQueryKeys.detail(formMetadataParams);

    return useSuspenseQuery({
        queryKey: formMetadataQueryKey,
        queryFn: () => getFormMetadata(formMetadataParams),
    });
};
